//in the API this is considered an alertPreference, but it's referred to as an 'Alert' in the UI.
export class AlertPreference {
    alertId: string;
    name: string;
    machineId: string;
    email: boolean = false;
    textMessage: boolean = false;
    // pushNotification: boolean = false; // disabled for IAAPA.
    //these properties won't come from the server, they're computed for the ui
    allSelected: boolean;
    notificationDisplay: string;
    //get the name and id from a base Alert
    baseFromJson(dict: any): AlertPreference {
        this.name = dict.alertName || dict.name;
        this.alertId = dict.alertId;
        this.machineId = dict.machineId;
        this.email = !!dict.email;
        this.textMessage = !!dict.textMessage;
        // this.pushEnabled = !!dict.pushNotification;
        return this;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/alert-preference.ts